import { z } from "zod";
import { smbOrderStatusSchema, smbStepStateSchema, smbJsonObjectSchema } from "./smb";

export const SMB_STEPS = [
  { key: "templates", label: "Templates", order: 0 },
  { key: "intake", label: "Intake", order: 1 },
  { key: "enrichment", label: "Enrichment", order: 2 },
  { key: "handoff", label: "Hand-off", order: 3 },
  { key: "generation", label: "Generation", order: 4 },
  { key: "review", label: "Review", order: 5 },
  { key: "publish", label: "Publish", order: 6 },
  { key: "portal", label: "Portal", order: 7 },
] as const;
export const smbStepKeySchema = z.enum(["templates", "intake", "enrichment", "provision", "apply", "research", "services", "personas", "confidence", "handoff", "handoff.attach_records", "handoff.start_run", "generation", "review", "publish", "publish.snapshot", "portal"]);
export type SmbStepKey = z.infer<typeof smbStepKeySchema>;
export const smbCreateTestOrderSchema = z.object({
  externalId: z.string().trim().min(8).max(160).optional(),
  packageId: z.string().uuid().optional(),
}).strict();
export const smbRunOptionsSchema = z.object({ dryRun: z.boolean().optional() }).strict();
export const smbListQuerySchema = z.object({
  status: z.string().max(80).optional(), package: z.string().max(160).optional(),
  brand: z.string().max(160).optional(), test: z.string().max(10).optional(),
  q: z.string().trim().max(160).optional(),
  page: z.coerce.number().int().min(1).max(10000).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(25),
}).strict();
export type SmbListQuery = z.infer<typeof smbListQuerySchema>;
export const smbAdminOrderSchema = z.object({
  id: z.string(), externalId: z.string(), status: smbOrderStatusSchema, isTest: z.boolean(),
  packageId: z.string().nullable(), brandId: z.string().nullable(),
  confidenceScore: z.number().nullable(), costCapUsd: z.string().nullable(),
  createdAt: z.string(), stageStartedAt: z.string(),
});
export const smbRestartOrderSchema = z.object({
  packageId: z.string().uuid(),
  requestId: z.string().uuid(),
}).strict();
export const smbRestartOrderResponseSchema = z.object({
  order: smbAdminOrderSchema,
  alreadyExisted: z.boolean(),
});
export const smbAdminEventSchema = z.object({
  id: z.string(), type: z.string(), at: z.string(), detailJson: smbJsonObjectSchema,
});
export const smbAdminStepSchema = z.object({
  key: smbStepKeySchema, label: z.string(), order: z.number(), registered: z.boolean(),
  supportsDryRun: z.boolean(), supportsRewind: z.boolean(),
  state: smbStepStateSchema.nullable(), description: smbJsonObjectSchema.nullable(),
  events: z.array(smbAdminEventSchema),
});
export const smbAdminDetailSchema = z.object({
  order: smbAdminOrderSchema,
  brand: z.object({ id: z.string(), name: z.string(), logoUrl: z.string().nullable() }).nullable(),
  package: z.object({ id: z.string(), name: z.string() }).nullable(),
  costUsd: z.number().nullable(), steps: z.array(smbAdminStepSchema),
  events: z.array(smbAdminEventSchema),
});
export const smbAdminListSchema = z.object({
  orders: z.array(smbAdminOrderSchema), total: z.number(), page: z.number(), pageSize: z.number(),
});
export type SmbAdminDetail = z.infer<typeof smbAdminDetailSchema>;
export type SmbAdminStep = z.infer<typeof smbAdminStepSchema>;
